<template>
  <div v-if="filteredPages.length > 1" class="container mx-auto mb-20">
    <div class="my-5 w-full">
      <div class="max-w-max mx-auto">
        <div class="flex">
          <!-- Previous Button -->
          <button 
            @click="handleSubmitElements($event, previousPage(activePage))"
            class="rounded-l-full py-2 px-2 leading-6 text-bold disabled:opacity-50" 
            :disabled="isFirstPage(activePage)"
            :style="{ 
              backgroundColor: tourSettings.contrast_color, 
              color: tourSettings.contrast_text_color 
            }"
          >
            <ChevronLeftIcon class="w-5 h-5"/>
          </button>

          <!-- Page Counter -->
          <div
            class="inline-grid mx-[2px] h-10 px-4 text-center place-items-center" 
            :style="{ 
              backgroundColor: tourSettings.contrast_color, 
              color: tourSettings.contrast_text_color 
            }"
          >
            <div>{{ getPageNumber(activePage) }} / {{ filteredPages.length }}</div>
          </div>

          <!-- Next Button -->
          <button 
            @click="handleSubmitElements($event, nextPage(activePage))"
            class="rounded-r-full py-1 px-2 leading-6 disabled:opacity-50" 
            :disabled="isLastPage(activePage)"
            :style="{ 
              backgroundColor: tourSettings.contrast_color, 
              color: tourSettings.contrast_text_color 
            }"
          >
            <ChevronRightIcon class="w-5 h-5"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'VuePagination',
  components: {
    ChevronLeftIcon,
    ChevronRightIcon
  },
  props: {
    filteredPages: {
      type: Array,
      required: true
    },
    activePage: {
      type: String,
      required: true
    },
    tourSettings: {
      type: Object,
      default: () => ({})
    },
    handleSubmitElements: {
      type: Function,
      required: true
    },
    isFirstPage: {
      type: Function,
      required: true
    },
    isLastPage: {
      type: Function,
      required: true
    },
    getPageNumber: {
      type: Function,
      required: true
    },
    nextPage: {
      type: Function,
      required: true
    },
    previousPage: {
      type: Function,
      required: true
    }
  }
}
</script>
